import React from "react";
import ValueCell from "./value_cell";

import {LlmRunScore} from "../../../../common/flowmaster/types/llm_run";

import {
  problemComplexities,
  ProblemComplexityKey,
} from "../../../../common/types/query_domain";

import {
  questionComplexities,
  QuestionComplexity,
  ScoreAnalysis,
} from "../../types";

type Props = {
  groupedScores: {
    groups: Record<
      ProblemComplexityKey,
      Record<QuestionComplexity["key"], ScoreAnalysis>
    >;
    ungrouped: LlmRunScore[];
  };
  showAnalysis: (item: ScoreAnalysis) => void;
};

export default function QueryDomainResults({
  groupedScores,
  showAnalysis,
}: Props) {
  return (
    <table>
      <thead>
        <tr>
          <th></th>
          {questionComplexities.map(complexity => (
            <th key={complexity.key}>{complexity.name}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {problemComplexities.map(pComplexityKey => (
          <tr key={pComplexityKey}>
            <th>{pComplexityKey}</th>
            <>
              {questionComplexities.map(qComplexity => {
                const item =
                  groupedScores.groups?.[qComplexity.key]?.[pComplexityKey];
                return (
                  <ValueCell
                    key={qComplexity.key}
                    value={item?.score}
                    onClick={() => showAnalysis(item)}
                  />
                );
              })}
            </>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
